import React, {Component} from 'react';
import {Form, Control, Fieldset, Errors} from 'react-redux-form';
import _ from "lodash";
import {formatMoney} from "accounting-js";
import MunsModal from "./widgets/municipalities-modal";
import ConagoModal from "./widgets/conago-modal";
import ActorsModal from "./widgets/actors-modal";
import {toInt} from "../parsers";
import { minValue} from "../field_validations";
import ActivityWidget from "./widgets/activities";
import {confirmAlert} from "react-confirm-alert";

export default class ProjectGoalsEdit extends Component {
	render () {
		const {projects} = this.props;
		let totalGoals = 0; let totalSpent = 0;
		_.map(projects.goals, (o) => {
			totalGoals += o.total;
			totalSpent += o.amounts ? o.amounts.spent : 0;
		});
		return (
			<div className="columns">
				{this.state.modalShow ? <GoalEditModal selectedGoal={this.state.selectedGoal} active={this.state.modalShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
				{!this.state.modalShow ?
				<div className="column">
					<Form model="projects.goals" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<div className="tags has-addons">
									<span className="tag is-medium">Monto total de las metas</span>
									<div className="tag is-medium is-primary">
										{formatMoney(totalGoals)}
									</div>
								</div>
							</div>

							<div className="control">
								<div className="tags has-addons">
									<span className="tag is-medium">Monto total ejercido</span>
									<div className="tag is-medium is-primary">
										{formatMoney(totalSpent)}
									</div>
								</div>
							</div>
						</div>

						<br/> <br/>

						{/*<GoalSelect goals={_.filter(_.sortBy(goals.list, ['name']), (o) => o.modality.slug === projects.project.modality.slug)} addGoal={this._addGoal} canAdd={() => this._canAddActivities()} />*/}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-primary" onClick={() => this._addGoal()}>
					        <span className="icon">
					            <i className="fa fa-plus" />
					        </span>
									<span>Agregar meta</span>
								</button>
							</div>
						</div>

						<table className="inm-table" style={{marginTop: '50px'}}>
							<thead>
							<tr>
								<th>Código</th>
								<th>Nombre</th>
								<th className="has-text-right">Monto total</th>
								<th className="has-text-right" style={{paddingRight: '0'}}>Monto ejercido</th>
							</tr>
							</thead>
							<tbody>
							{_.map(projects.goals, (row, key) => {
								/*totalGoals += row.total;
								totalSpent += row.amounts ? row.amounts.spent : 0;*/
								return [
									<tr key={`goal-${key}`}>
										<td>
											<div className="actions">
												<button type="button" style={{cursor: 'pointer'}} onClick={() => this._openGoalModal(row)}><i className="fa fa-edit" /></button>
												<button type="button" style={{cursor: 'pointer'}} onClick={() => this._removeGoal(row.proigualdad_goal_id)}><i className="fa fa-trash-o" /></button>
											</div>
											<strong>{row.code}</strong>
										</td>
										<td>
											{row.name}
											{(row.mandatory === 1) ?
												<small className="help is-primary is-small">Esta meta es
													obligatoria</small> : ''}
										</td>
										<td className="has-text-right">{formatMoney(row.total)}</td>
										<td className="has-text-right">{formatMoney(row.amounts.spent)}</td>
									</tr>
								]
							})}
							</tbody>
						</table>

						<br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
							</div>
							<div className="control">
								<Control.button type="submit" model="projects.goals" className="button is-large is-inm-purple" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>
					</Form>
				</div>:''}
			</div>
		)
	}

	constructor() {
		super();
		this.state = {
			modalShow: false,
			munShow: false,
			conagoShow: false,
			actorsShow: false,
			goalMuns: [],
			goalConago: [],
			goalActors: [],
			selectedGoal: 0,
			canEdit: false
		};
	}

	_submitForm(values) {
		this.props.projectGoalsSave(this.props.match.params.id, values);
	}

	_addGoal() {
		return this.setState({
			modalShow: true,
			selectedGoal: undefined,
		})
	}

	_removeGoal(goal) {
		let {goals} = this.props.projects;
		let goalIndex = _.findKey(goals, {proigualdad_goal_id: _.toInteger(goal)});
		if (goals[goalIndex].mandatory === 0) {
			confirmAlert({
				title: '¿Esta seguro?',
				message: 'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',
				confirmLabel: 'Eliminar',
				cancelLabel: 'Cancelar',
				onConfirm: () => this.props.remove('projects.goals', goalIndex)
			});
		}
	}

	_openGoalModal(row){
		this.props.change('projects.edit',{...row});
		let editGoal = _.findKey(this.props.projects.goals, {proigualdad_goal_id: row.proigualdad_goal_id});
		return this.setState({
			modalShow: true,
			selectedGoal: editGoal,
		})
	}

	_toggleModal() {
		this.props.reset('projects.edit');
		return this.setState({
			modalShow: !this.state.modalShow,
			selectedGoal: 0
		});
	}

	_validateSave() {
		const {projects} = this.props;
		let pc = _.find(projects.permissions, (o) => {
			return o === 'Create';
		});
		let pu = _.find(projects.permissions, (o) => {
			return o === 'Update';
		});

		if (pu || pc) {
			return false;
		} else {
			return true;
		}
	}
}

class GoalEditModal extends Component {
	render() {
		const {projects, goals, resource_concepts} = this.props;
		const {edit} = projects;
		return (
			<Fieldset model="projects.edit" className="column">
				{this.state.munShow ? <MunsModal active={this.state.munShow} closeModal={() => this._toggleMunModal()}
				                                 selectedMuns={projects.edit.municipalities}
				                                 selectedGoal={this.state.selectedGoal}
				                                 muns={this.props.municipalities} add={this.props.add}
				                                 isMod={projects.project ? projects.project.modality_id:undefined}
				                                 remove={this.props.remove} conclusion={this.state.canEdit}/> : ''}
				{this.state.conagoShow ?
					<ConagoModal active={this.state.conagoShow} closeModal={() => this._toggleConagoModal()}
					             selectedConago={projects.edit.conago_clauses}
					             selectedGoal={this.state.selectedGoal} conagoClauses={this.props.directories}
					             add={this.props.add} remove={this.props.remove} conclusion={this.state.canEdit}/> : ''}
				{this.state.actorsShow ?
					<ActorsModal active={this.state.actorsShow} closeModal={() => this._toggleActorsModal()}
					             selectedActors={projects.edit.actors}
					             selectedGoal={this.state.selectedGoal} actors={this.props.directories}
					             add={this.props.add} remove={this.props.remove} conclusion={this.state.canEdit}/> : ''}

				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<div className="tags has-addons">
							<span className="tag is-medium">Monto total</span>
							<div className="tag is-medium is-primary">
								{formatMoney(edit.total ? edit.total:0)}
							</div>
						</div>
					</div>

					<div className="control">
						<div className="tags has-addons">
							<span className="tag is-medium">Monto ejercido</span>
							<div className="tag is-medium is-primary">
								{formatMoney(edit.amounts ? edit.amounts.spent:0)}
							</div>
						</div>
					</div>

					{_.size(edit.municipalities) > 0 && projects.project.modality.slug === 'modalidad-iii' ?
						<div className="control">
							<div className="tags has-addons">
													<span className="tag is-medium is-dark">
														Gasto por CDM
													</span>
								<div className="tag is-medium is-inm-purple">
									{formatMoney(edit.total / _.size(edit.municipalities))}
								</div>
							</div>
						</div> : ''}
				</div>


				<div className="hero is-light">
					<div className="hero-body">
						<div className="field">
							<div className="control">
								<label htmlFor="proigualdad_goal_id" className="label">Meta</label>
								<div className="select">
									<Control.select model=".proigualdad_goal_id" changeAction={(m,v) => this._addGoal(m,v)}>
										<option value='' defaultValue>--- Selecciona una meta ---</option>
										{!_.isEmpty(goals.list) && _.map(_.filter(_.sortBy(goals.list, ['name']), (o) => o.modality.slug === projects.project.modality.slug), (option, key) => {
											return <option key={key} value={option.id}>{_.truncate(`${option.id}.${option.type} - ${option.name}`, {'length': 100})}</option>;
										})}
									</Control.select>
								</div>
								{projects.edit && projects.edit.proigualdad_goal_id ?
									'':<small className="help has-text-danger">Debes seleccionar una meta</small>}
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="goal-rc" className="label">Conceptos de gasto</label>
								<div className={`select`}>
									<Control.select model={`.resource_concept_id`} id={`goal-rc`} parser={toInt} >
										<option value={0} defaultValue>--- Conceptos de gasto ---</option>
										{_.map(resource_concepts.list, (res, t) => {
											return <option value={res.id} key={t}>{_.truncate(res.name, {'length': 100})}</option>;
										})}
									</Control.select>
								</div>
								{projects.edit && projects.edit.resource_concept_id ?
									'':<small className="help has-text-danger">Debes indicar el concepto de gasto.</small>}
							</div>
						</div>

						<div className="field is-grouped is-grouped-multiline">
							{projects.project.modality.slug === 'modalidad-i' ?
							<div className="control">
								<label htmlFor="goal-ga" className="label">Area geográfica</label>
								<div className="select">
									<Control.select model={`.geographic_area`}
									                id={`goal-ga`}
									                ref={`goal-ga`}>
										<option value="">--- Area geográfica ---</option>
										<option value="Estatal">Estatal</option>
										<option value="Municipios">Municipios</option>
										<option value="Todos los municipios">Todos los municipios
										</option>
									</Control.select>
								</div>
								{edit && edit.geographic_area ?
									'':<small className="help has-text-danger">Seleccionar area geográfica.</small>}
							</div>:''}
						</div>
					</div>
				</div>
				<br/>

				<div className="field is-grouped is-grouped-multiline">
					<div className="control">
						<div className="message is-small is-primary">
							<div className="message-body">
								<div className="field">
									<div className="control">
										<label htmlFor={`.is_continuing`} className="checkbox">
											<Control.checkbox model={`.is_continuing`} id={`.is_continuing`} className="checkbox" isToggle={true}/>
											<span style={{whiteSpace:'normal'}}> Meta de continuidad</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					{projects.project.modality.slug === 'modalidad-i' ?
						<div className="control">
							<div className="tags has-addons">
													<span style={{cursor: 'pointer'}} className="tag is-medium is-light"
													      onClick={() => this._openConagoModal(edit.proigualdad_goal_id, edit.conagoClauses, false)}>Metas CONAGO</span>
								<span className="tag is-medium is-white">{_.size(edit.conago_clauses)}</span>
							</div>
							{_.size(edit.conago_clauses) <= 0 ?
								<span className="help is-danger">Debes elegir al menos una meta CONAGO</span> : ''}
						</div>:''}

					<div className="control">
						<div className="tags has-addons">
												<span style={{cursor: 'pointer'}} className="tag is-medium is-light"
												      onClick={() => this._openActorsModal(edit.proigualdad_goal_id, edit.actors, false)}>Actores estratégicos</span>
							<span
								className="tag is-medium is-white">{_.size(edit.actors)}</span>
						</div>
					</div>

					{edit.geographic_area === 'Municipios' || projects.project.modality.slug === 'modalidad-iii' ?
						<div className="control">
							<div className="tags has-addons">
													<span style={{cursor: 'pointer'}}
													      className="tag is-medium is-light"
													      onClick={() => this._openMunModal(edit.proigualdad_goal_id, edit.municipalities, false)}>Seleccionar municipios</span>
								<span
									className="tag is-medium is-white">{_.size(edit.municipalities)}</span>
							</div>
							{_.size(edit.municipalities) === 0 ?
								<small className="help is-danger is-small">Seleccionar
									municipios participantes</small> : ''}
						</div> : ''}
				</div>

				<hr/>

				<div className="hero is-light">
					<div className="hero-body">
						<div className="hero-subsection">
							<div className="field">
								<ActivityWidget goal={edit}  {...this.props}/>
							</div>
						</div>
						<hr/>
						<h5 className="title is-5">Listado de actividades</h5>
						<div className="hero-subsection">
							<table className="table is-fullwidth is-bordered">
								<thead>
								<tr>
									<th className="has-text-centered">ID</th>
									<th>Actividad</th>
									<th className="has-text-centered">Cantidad</th>
									<th className="has-text-right">Total</th>
									<th className="has-text-right">Medio de verificación</th>
									<th className="has-text-right">Acciones</th>
								</tr>
								</thead>
								<tbody>
								{_.map(projects.edit.project_goal_activities, (act, j) => {
									//goalTotal += act.total;
									return [
										<tr key={j}>
											<td className="has-text-centered">{act.proigualdad_activity_id}</td>
											<td>{act.name}{act.mandatory === 1 ?
												<small className="help is-primary">Esta actividad es
													obligatoria</small> : ''}</td>
											<td className="has-text-centered">
												{act.allow_edit ?
													<div>
														<Control.text
															model={`projects.edit.project_goal_activities[${j}].quantity`}
															type="number" min={0} step={1}
															className="input"
															errors={{minValue: minValue(0)}}
															validateOn="change"
															changeAction={(model, value) => this._editActivity(j, model, value, act)}
															style={{width: '40%'}}/>
														<Errors
															model={`projects.edit.project_goal_activities[${j}].quantity`}
															show="touched" wrapper={(props) => <small
															className="help has-text-danger">{props.children}</small>}
															messages={{minValue: 'Minimo no admitido.'}}/>
													</div>
													: act.quantity}
											</td>
											<td className="has-text-right amount">{formatMoney(_.toNumber(act.total))}</td>
											<td className="has-text-right">{act.verification_media ? act.verification_media.name : ''}</td>
											<td className="has-text-right">
												<div className="field is-grouped">
													{act.allow_edit ? '' :
														<div className="control">
															<button className="button is-info"
															        type="button"
															        onClick={() => this.props.change(`projects.edit.project_goal_activities[${j}]`, {
																        ...act,
																        allow_edit: true
															        })}><i className="fa fa-edit"/>
															</button>
														</div>}
													{act.allow_edit ?
														<div className="control">
															<button className="button is-warning"
															        type="button"
															        onClick={() => this.props.change(`projects.edit.project_goal_activities[${j}]`, {
																        ...act,
																        allow_edit: false
															        })}><i className="fa fa-times"/>
															</button>
														</div> : ''}
													<div className="control">
														<button type="button"
														        className="button is-danger"
														        onClick={() => this._removeActivity(act.proigualdad_activity_id, projects.edit.proigualdad_goal_id)}>
															<i className="fa fa-trash"/></button>
													</div>
												</div>
											</td>
										</tr>
									];
								})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<br/>
				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<button type="button" className="button is-large" onClick={() => this.props.closeModal()}>
							Regresar
						</button>
					</div>
					<div className="control">
						<button type="button" className="button is-large is-inm-purple" onClick={() => this._validSave()} disabled={!_.isNumber(projects.edit.proigualdad_goal_id)}>
							Guardar
						</button>
					</div>
				</div>

				<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
			</Fieldset>
		);
	}

	constructor() {
		super();
		this.state = {
			modalShow: false,
			munShow: false,
			conagoShow: false,
			actorsShow: false,
			goalMuns: [],
			goalConago: [],
			goalActors: [],
			selectedGoal: 0,
			canEdit: false
		};
	}

	_validSave(){
		let {projects} = this.props;
		let {edit} = projects;
		//console.log('edit===>',edit);
		if(edit.proigualdad_goal_id && edit.resource_concept_id && !_.isEmpty(edit.project_goal_activities) &&
			_.size(edit.conago_clauses) > 0){
			if(edit.geographic_area && (edit.geographic_area === 'Municipios' || projects.project.modality.slug === 'modalidad-iii') && _.size(edit.municipalities) > 0){
				this._saveChanges(edit);
			}else if(projects.project.modality.slug === 'modalidad-i' && edit.geographic_area){
				this._saveChanges(edit);
			}else if(projects.project.modality.slug === 'modalidad-ii'){
				this._saveChanges(edit);
			}else {
				this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger');
			}
		}else {
			this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger');
		}
	}

	_saveChanges(edit){
		if(this.props.selectedGoal){
			this.props.change(`projects.goals[${this.props.selectedGoal}]`,{...edit})
			this.props.closeModal();
		}else {
			this.props.add('projects.goals', {...edit})
			this.props.closeModal();
		}
	}

	_addGoal(model, value) {
		const {goals, projects} = this.props;
		//let repeated = projects.goals && this.props.selectedGoal ? projects.goals[this.props.selectedGoal].proigualdad_goal_id:undefined;
		let repeated = _.findKey(this.props.projects.goals, {proigualdad_goal_id: _.toInteger(value)});
		let goal = _.find(goals.list, {id: _.toInteger(value)})


		if(value && this.props.selectedGoal && projects.goals[this.props.selectedGoal].proigualdad_goal_id === _.toInteger(value)){
			this.props.change('projects.edit',{
				...projects.goals[this.props.selectedGoal]
			})
		}else {
			if (value && goal &&  repeated === undefined) {
				this.props.change('projects.edit',{
					...goal,
					code: _.join([goal.id, goal.type], '.'),
					geographic_area: undefined,
					proigualdad_goal_id: _.toInteger(goal.id),
					resource_concept_id: undefined,
					project_goal_activities: [],
					total: 0,
					actors: [],
					conago_clauses: [],
					mandatory: goal.mandatory,
					amounts: {
						spent:0
					}
				})
				//this.props.change(model,value);
			} else {
				this.props.change('projects.edit',{
					proigualdad_goal_id: '',
				})
				//alert('No se pueden agregar metas duplicadas');
				this.props.setSystemNotification('¡Oh no!', 'No se pueden agregar metas duplicadas', 'danger');
			}
		}

	}

	_removeActivity(activity) {
		let {edit} = this.props.projects;
		//let goalIndex = _.findKey(goals, {proigualdad_goal_id: _.toInteger(goal)});
		let activityIndex = _.findKey(edit.project_goal_activities, {proigualdad_activity_id: _.toInteger(activity)});
		if (edit.project_goal_activities[activityIndex].mandatory !== 1) {
			this.props.remove(`projects.edit.project_goal_activities`, activityIndex);
			this.props.change(`projects.edit.total`, edit.total - edit.project_goal_activities[activityIndex].total);
		} else {
			this.props.setSystemNotification('¡Oh no!', 'No se puede eliminar una actividad obligatoria', 'danger');
			//alert('No se puede eliminar una actividad obligatoria');
		}
	}

	_editActivity(keyActivity, model, value, act) {
		let quantity = _.toNumber(value);
		let amount = _.toNumber(act.amount);
		this.props.change(model, quantity);
		if (quantity >= 0) {
			this.props.change(`projects.edit.project_goal_activities[${keyActivity}].total`, quantity * amount);
		}
	}

	_openMunModal(goal, selected, disable) {
		let {projects} = this.props;
		//let entity = _.find(this.props.entities.list, {short:state});
		let editGoal = _.findKey(this.props.projects.goals, {proigualdad_goal_id: goal});
		this.props.fetchMunicipalities(projects.project.state_id);
		return this.setState({
			munShow: true,
			goalMuns: selected,
			selectedGoal: editGoal,
			canEdit: disable
		});
	}

	_openConagoModal(goal, selected, disable) {
		let editGoal = _.findIndex(this.props.projects.goals, {proigualdad_goal_id: goal});
		return this.setState({
			conagoShow: true,
			goalConago: selected,
			selectedGoal: editGoal,
			canEdit: disable
		});
	}

	_openActorsModal(goal, selected, disable) {
		let editGoal = _.findKey(this.props.projects.goals, {proigualdad_goal_id: goal});
		return this.setState({
			actorsShow: true,
			goalActors: selected,
			selectedGoal: editGoal,
			canEdit: disable
		});
	}

	_toggleMunModal() {
		return this.setState({munShow: !this.state.munShow});
	}

	_toggleConagoModal() {
		return this.setState({conagoShow: !this.state.conagoShow});
	}

	_toggleActorsModal() {
		return this.setState({actorsShow: !this.state.actorsShow});
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects/goals.jsx